import { useEffect, useState } from "react";
import { Breakpoint, getActiveBreakpoints } from "../theming";

export function useActiveBreakpoints() {
  const [windowWidth, setWindowWidth] = useState(0)
  const [activeBreakpoints, setActiveBreakpoints] = useState<Record<Breakpoint, boolean>>({
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    xxl: false,
  })

  useEffect(() => {
    if (typeof window === 'undefined') return

    setWindowWidth(window.innerWidth)

    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    setActiveBreakpoints(getActiveBreakpoints(windowWidth))
  }, [windowWidth, setActiveBreakpoints])

  return {
    activeBreakpoints,
    windowWidth,
  }
}
